import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

type Scope = "offline_access" | "accounting.contacts.read";

@Model()
class XeroAuthorisation extends ApplicationRecord {
  static jsonapiType = "xero_authorisations";

  @Attr() code: string;

  @Attr() redirectUri: string;

  @Attr() region: string;

  @Attr() scopes: Scope[];

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default XeroAuthorisation;
